import { isServer } from '../utils';
function isCSSAssetLoaded(url) {
    return (
    // pre fetched (inlined) style tag
    document.querySelector(`style[data-href="${url}"]`) !== null ||
        // normal CSS import
        document.querySelector(`link[href="${url}"]`));
}
function injectStyleTag(url) {
    return new Promise((resolve, reject) => {
        const style = document.createElement('link');
        style.setAttribute('rel', 'stylesheet');
        style.setAttribute('type', 'text/css');
        style.setAttribute('href', url);
        style.addEventListener('load', () => resolve(url));
        style.addEventListener('error', e => reject(e));
        document.head.appendChild(style);
    });
}
export function loadAssets(assets) {
    if (isServer()) {
        return Promise.resolve();
    }
    return Promise.all(assets
        .filter(url => !isCSSAssetLoaded(url))
        .map(url => injectStyleTag(url)));
}
//# sourceMappingURL=loadAssets.js.map